export function getPaasPublicDemo() {
  return {
    status: "published",
    centro: "Centro de Informatica",
    description:
      "Dados de demonstracao para revisar a pagina publica sem acesso ao banco.",
    date: "24/06/2026 18:00:00",
    solution: {
      id: "demo-public-plan",
      status: "Ready",
      solution: [
        {
          bloco: "CI",
          nome: "101",
          tipo: "Sala de aula",
          capacidade: 45,
          acessivel: true,
          classes: [
            {
              codigo: "GDSCO0035",
              turma: "01",
              nome: "Arquitetura de Computadores",
              horario: "35M45",
              alunos: 38,
              departamento: "CI-DSC",
              docente: "Ewerton Monteiro Salvador",
              periodo: "2026.1"
            },
            {
              codigo: "GDSCO0021",
              turma: "01",
              nome: "Circuitos Logicos I",
              horario: "24M45",
              alunos: 33,
              departamento: "CI-DSC",
              docente: "Jose Antonio Gomes de Lima",
              periodo: "2026.1"
            }
          ]
        },
        {
          bloco: "CI",
          nome: "Lab 02",
          tipo: "Laboratorio",
          capacidade: 30,
          acessivel: false,
          classes: [
            {
              codigo: "GDSCO0043",
              turma: "01",
              nome: "Construcao de Compiladores I",
              horario: "24M45",
              alunos: 28,
              departamento: "CI-DSC",
              docente: "Maelso Bruno Pacheco Nunes Pereira",
              periodo: "2026.1"
            },
            {
              codigo: "GDSCO0050",
              turma: "02",
              nome: "Programacao Orientada a Objetos",
              horario: "46T23",
              alunos: 30,
              departamento: "CI-DI",
              docente: "Yuska Paola Costa Aguiar",
              periodo: "2026.1"
            }
          ]
        },
        {
          bloco: "CI",
          nome: "Auditorio",
          tipo: "Auditorio",
          capacidade: 80,
          acessivel: true,
          classes: [
            {
              codigo: "GDSCO0061",
              turma: "01",
              nome: "Inteligencia Artificial",
              horario: "24T23",
              alunos: 64,
              departamento: "CI-DCC",
              docente: "Andrei de Araujo Formiga",
              periodo: "2026.1"
            }
          ]
        }
      ]
    }
  };
}
